import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {StateProviderService} from '../../../shared/services/state-provider.service';
import {UserRoles} from '../../../shared/constants/user-roles.constant';
import {UserService} from '../../../shared/services/user.service';
import {PitMsalService} from '../../../shared/services/pit-msal.service';

@Component({
  selector: 'app-error-auth',
  templateUrl: './error-auth.component.html',
  styleUrls: ['./error-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorAuthComponent implements OnInit {

  constructor(
    private stateProviderService: StateProviderService,
    private userService: UserService,
    private authService: PitMsalService
  ) {}

  public currentUser: string;
  public userRoles = UserRoles;
  public get isMimicMode(): boolean {
    const realUserEmail = this.authService.getAccount()?.username;
    return this.userService.isMimicMode(realUserEmail);
  }

  ngOnInit(): void {
    this.currentUser = this.stateProviderService.getParam('user');
  }

  logout() {
    this.userService.resetUser();
    this.authService.logout();
  }

  resetMimic() {
    const userName1 = this.authService.getAccount()?.username;
    this.userService.setCurrentUserName(userName1.substring(0, userName1.indexOf('@')));
    window.location.reload();
  }
}
